import dynamic from "next/dynamic"
import { InferGetServerSidePropsType } from "next"
import clientPromise from "utils/backend/mongodb"

const All = dynamic(() => import("views/articles/MoviesApps/All"))

const MoviesApps = ({
  apps,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return <All apps={apps} />
}

export default MoviesApps

export const getServerSideProps = async () => {
  const client = await clientPromise
  const db = client.db(process.env.NEXT_PUBLIC_MONGODB_DB)

  const apps = await db
    .collection("apps")
    .aggregate([
      {
        $search: {
          // index: "default",
          text: {
            query: "مشاهدة افلام مسلسلات",
            path: [
              "submitters.submitterDescription",
              "submitters.translatedDescription.text",
            ],
            fuzzy: {
              maxEdits: 2,
              maxExpansions: 1,
            },
          },
        },
      },
      {
        $addFields: {
          score: {
            $meta: "searchScore",
          },
        },
      },
      {
        $match: {
          score: { $gt: 5 },
        },
      },
    ])
    .limit(50)
    .sort({ lastModified: -1 })
    .toArray()

  return {
    props: {
      apps: JSON.parse(
        JSON.stringify(
          apps.map((item: any) => ({
            trackId: item?.trackId,
            artworkUrl512: item?.artworkUrl512,
            trackName: item?.trackName,
            genres: item?.genres,
            description: item?.description.slice(0, 50) + "...",
            formattedPrice: item?.formattedPrice,
            submitterPrice: item?.submitterPrice,
            price: item?.price,
            submitter: item?.submitters?.[0],
            appRemoved: item?.appRemoved,
            hasInAppPurchases: item?.hasInAppPurchases,
          })),
        ),
      ),
    },
  }
}
